import React from 'react'
import classNames from 'classnames'
import { PaymentInfo } from '@/services/PifCheckoutService'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

interface PrefilledCreditCardInputProps {
  savedPayment: PaymentInfo
  changeCard: () => void
  className?: string
}

export const PrefilledCreditCardInput: React.FC<PrefilledCreditCardInputProps> = ({
  savedPayment,
  changeCard,
  className,
}) => {
  const { t } = useTranslate('pif')
  const { expireDate } = savedPayment
  return (
    <>
      <div
        onClick={changeCard}
        className={classNames(
          'space-between photon-paragraph-md mt-1 flex rounded border-b-0 bg-core-gray-100 px-2 py-2.5 text-gray-600 focus-visible:border-b-0',
          className,
        )}
      >
        <div className="pl-1">
          <span className="pr-1">••••</span> {savedPayment.last4}
        </div>
        <div className="ml-auto cursor-pointer text-oxide">
          <Translate t={t} i18nKey="changeCreditCard">
            Change Card
          </Translate>
        </div>
      </div>
      <div className="-mb-5 pt-1 text-center text-xs opacity-30">
        <Translate t={t} i18nKey="cardExpiresOn" values={{ expireDate }}>
          Expires: {{ expireDate }}
        </Translate>
      </div>
    </>
  )
}
